import { Component, Input, OnInit } from '@angular/core';
import { ReportDetail } from '../report.manager.model';
import { Constants } from '../../../constants.new';
import * as _ from 'lodash';

@Component({
    selector: 'further-limit-panel-tax-savings',
    template: `
        <div style="display: flex; white-space: nowrap; gap: 50px; flex-wrap: wrap;">
            <div style="display: flex; align-items: baseline; gap: 5px;">
                <label>Tax Year: </label>
                <select [(ngModel)]="report.criteria.taxYear" class="form-select-sm" style="width: 80px;">
                    <option [ngValue]=""></option>
                    @for (year of availableYears; track year) {
                        <option [ngValue]="year">{{ year }}</option>
                    }
                </select>
            </div>
            <div style="display: flex; align-items: baseline; gap: 5px;">
                <label>Filing Deadline Range:</label>
                <weissman-datetime
                    [(inputDate)]="report.criteria.filingDeadlineStart"
                    [dateOnly]="true"
                    [timeZone]="'Central'"
                >
                </weissman-datetime>
                to
                <weissman-datetime
                    [(inputDate)]="report.criteria.filingDeadlineEnd"
                    [dateOnly]="true"
                    [timeZone]="'Central'"
                    [rangeEnd]="true"
                >
                </weissman-datetime>
            </div>
            <div style="display: flex; gap: 5px; align-items: baseline;">
                <label>Property Type: </label>
                <select multiple [(ngModel)]="report.criteria.propertyTypeIDs" class="form-select-sm">
                    @for (propType of propertyTypes; track propType) {
                        <option [ngValue]="propType.propertyTypeId">{{ propType.name }}</option>
                    }
                </select>
            </div>
            <div style="display: flex; gap: 10px; align-items: baseline;">
                <label>Is Preliminary:</label>
                <label style="margin-right: 15px;">
                    <input
                        type="radio"
                        name="is-preliminary"
                        [value]="true"
                        [(ngModel)]="report.criteria.isPreliminary"
                    />
                    Yes
                </label>
                <label>
                    <input
                        type="radio"
                        name="is-preliminary"
                        [value]="false"
                        [(ngModel)]="report.criteria.isPreliminary"
                    />
                    No
                </label>
            </div>
        </div>
    `,
    standalone: false,
})
export class FurtherLimitPanelTaxSavingsComponent implements OnInit {
    constructor(private constants: Constants) {}

    @Input() report: ReportDetail;
    @Input() availableYears: number[];
    @Input() hasRyanPrivatePermission: boolean;

    propertyTypes: any[];

    ngOnInit() {
        if (!this.report.criteria.taxYear) {
            const newYearValue = new Date().getFullYear() - 3;
            this.report.criteria.taxYear = newYearValue;
        }

        this.propertyTypes = _.map(this.constants.PropertyTypeNames, (name: string, id: number) => {
            return {
                name: name,
                propertyTypeId: Number(id),
            };
        });

        this.report.criteria.propertyTypeIDs = this.report.criteria.propertyTypeIDs || [1, 2, 3, 4];
        if (this.report.criteria.isPreliminary === undefined) {
            this.report.criteria.isPreliminary = false;
        }
    }
}
